import React from 'react';
import styled from 'styled-components';


export default function PhoneSMSAuthScene({startCounting, expireTime, verificationCode,onChangeCode, phoneNum, validPhoneNum, onChangePhoneNum,  onReqSMSAuth}) {

    return (
        <PresenterSection>
            <SectionHeader>
                <HeaderTitle>휴대폰 번호를 인증해 주세요</HeaderTitle>
                <HeaderDescription>챌린지 안내 및 상품 수령을 위해 필요해요</HeaderDescription>
            </SectionHeader>
            <SectionBody>
                <PhoneInputWrapper>
                    <FieldFlexWrapper>
                        <FieldInput type={'number'} value={phoneNum} onChange={(e)=>{if(onChangePhoneNum)onChangePhoneNum(e.target.value)}} placeholder={"‘-’없이 입력해 주세요"} />
                    </FieldFlexWrapper>
                    {
                        (validPhoneNum === true)
                        ?(<SMSReqButton onClick={()=>{if(onReqSMSAuth)onReqSMSAuth();}}>{(startCounting===true)?("재요청"):("인증요청")}</SMSReqButton>)
                        :(<DisabledSMSReqButton>인증요청</DisabledSMSReqButton>)
                    }
                    
                </PhoneInputWrapper>
                <PhoneFieldNote>
                    {((startCounting===true))?('인증코드가 발송되었어요.'):('')}
                </PhoneFieldNote>
                <ConfirmInputWrapper>
                    <FieldInput type={'number'} value={verificationCode} onChange={(e)=>{if(onChangeCode)onChangeCode(e.target.value)}} placeholder={"인증번호 6자리를 입력해 주세요"} />
                    <ExpireTime>{expireTime}</ExpireTime>
                </ConfirmInputWrapper>
            </SectionBody>
            
        </PresenterSection>
    );
}

export const PresenterSection = styled.div`
    height : 100%;
    flex: 1 1 auto;
    padding: 0 calc(100vw * (20 / 375)); 
`;

export const SectionHeader = styled.div`
    margin-top : calc(100vw * (43 / 375)); 
    margin-bottom : calc(100vw * (36 / 375)); 
`
export const HeaderTitle = styled.div`
    font-style: normal;
    font-weight: 700;
    font-size: calc(100vw * (23 / 375)); 
    line-height: calc(100vw * (29 / 375)); 
    color: #121212;
    margin-bottom : calc(100vw * (8 / 375)); 
`
export const HeaderDescription = styled.div`
    font-style: normal;
    font-weight: 500;
    font-size: calc(100vw * (16 / 375));
    line-height: calc(100vw * (19 / 375));
    color: #7F7F7F;
`
export const SectionBody = styled.div``

export const PhoneInputWrapper = styled.div` 
    display: flex;
`;
export const PhoneFieldNote = styled.div`
    height: calc(100vw * (26 / 375));
    min-height: calc(100vw * (26 / 375));

    font-style: normal;
    font-weight: 500;
    font-size: calc(100vw * (12 / 375));

    color: #FF7517;
`
export const SMSReqButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFCF19;
    border-radius: 5px;
    padding: calc(100vw * (11 / 375)) calc(100vw * (19 / 375));
    min-width : calc(100vw * (98 / 375));
    white-space: nowrap;
    text-align : center;
    flex: 0 1 auto;
    font-style: normal;
    font-weight: bold;
    font-size: calc(100vw * (16 / 375));
    color: #121212;
`

export const DisabledSMSReqButton = styled(SMSReqButton)`
    background: #D8D8D8;
    color: #989898;
`

export const ConfirmInputWrapper = styled.div`
    margin-bottom : calc(100vw * (30 / 375));
    position : relative;
`;
export const FieldFlexWrapper = styled.div`
    flex: 1 1 auto;
    margin-right: calc(100vw * (10 / 375));
`
export const FieldInput = styled.input`
    width : 100%;
    background: #FFFFFF;
    border: 1px solid #D5D5D5;
    box-sizing: border-box;
    border-radius: 5px;
    font-style: normal;
    font-weight: normal;
    font-size: calc(100vw * (14 / 375));
    padding: calc(100vw * (12 / 375)) calc(100vw * (10 / 375));
    &::placeholder{
        font-style: normal;
        font-weight: normal;
        font-size: calc(100vw * (14 / 375));
        color: #C6C6C6;
    }
`
export const ExpireTime = styled.div`
    position: absolute;
    right: calc(100vw * (13 / 375));
    top: 0;
    bottom: 0;
    margin: auto;
    height: fit-content;
`